// Password.jsx 

import { useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FaArrowRightToBracket } from "react-icons/fa6";
import "../../css/Auth/Password.css";
import AuthCard from "../../components/ui/Cards/AuthCard";
import Input from "../../components/ui/Input/Input";
import logo from "../../assets/images/logo1.png";
import logo1 from "../../assets/images/logo3.png";
import logo2 from "../../assets/images/Frame 47.png";
import logo3 from "../../assets/images/Frame 35.png";
import logo4 from "../../assets/images/logo7.png";
import logo5 from "../../assets/images/logo4.png";
import LogoBottom from "../../assets/images/shreepuram_vijay_prateek.png";
import api from "../../api/axios";
import Botton from "../../components/ui/Button/Button";
import { connectSocket } from "../../socket/Socket";
import {
  saveAccessToken,
  saveRefreshToken,
  saveUserId,
  setUserRole,
  setkycStatus,
  setUserFullName,
  setUserProfile,
  setAdhaarVerified,
} from "../../utils/auth";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";

const Password = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const phoneNumber = location.state?.phoneNumber;

  const [formData, setFormData] = useState({ password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  // Password validation function
  const validatePassword = (pass) => {
    if (!pass) return "";
    if (pass.length < 6) return "Password must be at least 6 characters";
    if (pass.length > 10) return "Password must not exceed 10 characters";
    return "";
  };

  // Handle password change with max length limit
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setFormData((prev) => ({ ...prev, password: value }));
      const validationError = validatePassword(value);
      setPasswordError(validationError);
      if (error) setError("");
    }
  };

  const handleLogin = async () => {
    // Validation checks
    if (!formData.password) {
      setError("Please enter your password");
      return;
    }
    
    // Check password length
    if (formData.password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }
    
    if (formData.password.length > 10) {
      setError("Password must not exceed 10 characters");
      return;
    }

    if (!phoneNumber) {
      toast.error("Session expired. Please login again.");
      navigate("/login");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await api.post(
        "/auth/login",
        {
          phone: phoneNumber,
          password: formData.password,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const { accessToken, refreshToken, user } = response.data;

      // ================= TOKEN STORAGE ================= //
      saveAccessToken(accessToken);
      saveRefreshToken(refreshToken);

      // ================= USER DATA ================= //
      saveUserId(user.userId);
      setUserRole(user.role);
      setAdhaarVerified(user.adhaarVerified);
      setkycStatus(user.kycStatus);
      setUserFullName(user.fullName);
      setUserProfile(user.profilePic);

      // ================= SOCKET ================= //
      if (user.userId) {
        connectSocket(user.userId);
      }

      toast.success("Login successful!");

      // ================= REDIRECT ================= //
      navigate("/feed/prime");

    } catch (err) {
      console.error("Login Error:", err?.response?.data || err.message);

      const message =
        err?.response?.data?.message || "Invalid password. Please try again.";

      setError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard
      allImg={[logo3, logo2, logo4, logo5, logo1]}
      headLogo={logo}
      msgInput="Enter your login password "
      title="Welcome To Bharat Jagriti ™"
      description="EXPLORE THE TRUTH TO THE WORLD"
      pageTitle="Password"
      bottomName="Powered by Sripuram"
      bottomImg={LogoBottom}
    >
      {/* Password length hint */}
      <small style={{ 
        display: 'block', 
        marginBottom: '5px', 
        fontSize: '12px', 
        color: '#666',
        textAlign: 'left',
        width: '300px'
      }}>
        Password must be 6-10 characters
      </small>

      <div
        style={{
          width: "300px",
          margin: "5px 0",
          position: "relative",
        }}
      >
        <Input
          placeholder="Enter Your Password"
          className={"password_inputs_fields"}
          type={showPassword ? "text" : "password"}
          value={formData.password}
          inputName="password"
          onKeyPress={(e) => e.key === "Enter" && handleLogin()}
          onchangeInput={handlePasswordChange}
          length={50}
          disabled={loading}
          loading={loading}
          style={{ paddingRight: "40px" }}
        />

        {/* Eye Icon */}
        <span
          onClick={() => setShowPassword((prev) => !prev)}
          style={{
            position: "absolute",
            right: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#666",
            fontSize: "18px",
          }}
        >
          {showPassword ? <FaEye /> : <FaEyeSlash />}
        </span>
      </div>

      {/* Password length indicator */}
      {formData.password && (
        <small style={{ 
          fontSize: "12px", 
          color: formData.password.length >= 6 && formData.password.length <= 10 ? "green" : "orange",
          marginTop: "5px",
          display: "block",
          width: "300px",
          textAlign: "left"
        }}>
          {/* {formData.password.length}/10 characters  */}
          {/* {formData.password.length < 6 && " (min 6 needed)"} */}
          {formData.password.length > 10 && " (max 10 allowed)"}
        </small>
      )}

      {/* Password error message */}
      {passwordError && (
        <small style={{ color: "red", fontSize: "12px", marginTop: "5px", display: "block", width: "300px", textAlign: "left" }}>
          {passwordError}
        </small>
      )}

      {/* Login error message */}
      {error && !passwordError && (
        <div className="error-message text-red-500" style={{ color: "red", fontSize: "12px", marginTop: "5px", width: "300px", textAlign: "left" }}>
          {error}
        </div>
      )}

      <Botton
        onClick={handleLogin}
        className={"NextBtn mt-3"}
        children={`${loading ? "Logging in..." : "Login"}`}
        icon={FaArrowRightToBracket}
        disabled={
          !formData.password ||
          formData.password.length < 6 ||
          formData.password.length > 10 ||
          loading
        }
        style={{
          opacity: (
            !formData.password ||
            formData.password.length < 6 ||
            formData.password.length > 10
          ) ? 0.6 : 1,
          cursor: (
            !formData.password ||
            formData.password.length < 6 ||
            formData.password.length > 10
          ) ? "not-allowed" : "pointer"
        }}
      />

      <p className="text-center mt-3 small fw-bold">
        <Link
          to="/forget-password"
          className="text-primary cursor-pointer fw-semibold reset_btn"
        >
          Forgot Password?
        </Link>
      </p>
    </AuthCard>
  );
};

export default Password;


// import { useState } from "react";
// import { useLocation, useNavigate, Link } from "react-router-dom";
// import { FaArrowRightToBracket } from "react-icons/fa6";
// import "../../css/Auth/Password.css";
// import AuthCard from "../../components/ui/Cards/AuthCard";
// import Input from "../../components/ui/Input/Input";
// import logo from "../../assets/images/logo1.png";
// import logo1 from "../../assets/images/logo3.png";
// import logo2 from "../../assets/images/Frame 47.png";
// import logo3 from "../../assets/images/Frame 35.png";
// import logo4 from "../../assets/images/logo7.png";
// import logo5 from "../../assets/images/logo4.png";
// import LogoBottom from "../../assets/images/shreepuram_vijay_prateek.png";
// import api from "../../api/axios";
// import Botton from "../../components/ui/Button/Button";
// import { connectSocket } from "../../socket/Socket";
// import {
//   saveToken,
//   saveUserId,
//   setUserRole,
//   setkycStatus,
//   setUserFullName,
//   setUserProfile,
//   setAdhaarVerified,
// } from "../../utils/auth";
// import { FaEye, FaEyeSlash } from "react-icons/fa";

// const Password = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const phoneNumber = location.state?.phoneNumber;

//   const [formData, setFormData] = useState({ password: "" });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [showPassword, setShowPassword] = useState(false);

//   const handleLogin = async () => {
//     if (!formData.password) {
//       setError("Please enter your password");
//       return;
//     }

//     setLoading(true);
//     setError("");

//     try {
//       const response = await api.post(
//         "auth/login",
//         { phone: phoneNumber, password: formData.password },
//         { headers: { "Content-Type": "application/json" } },
//       );

//       saveToken(response.data.token);
//       saveUserId(response.data.user.userId);
//       setUserRole(response.data.user.role);
//       setAdhaarVerified(response.data.user.adhaarVerified);
//       setkycStatus(response.data.user.kycStatus);

//       setUserFullName(response.data.user.fullName);
//       setUserProfile(response.data.user.profilePic);

//       // ================= SOCKET START ================= //
//       if (response.data.user.userId) {
//         connectSocket(response.data.user.userId);
//       }
//       // ================= SOCKET END ================= //

//       // alert("Login Successful!");
//       navigate("/feed/prime");
//     } catch (err) {
//       // setError(err.response?.data?.message || "Invalid phone number or password.");
//       setError(err.response?.data?.message || "Invalid  password.");
//     }

//     setLoading(false);
//   };

//   return (
//     <AuthCard
//       allImg={[logo3, logo2, logo4, logo5, logo1]}
//       headLogo={logo}
//       msgInput="Enter your login password "
//       title="Welcome To Bharat Jagriti ™"
//       description="EXPLORE THE TRUTH TO THE WORLD"
//       pageTitle="Password"
//       bottomName="Powered by Sripuram"
//       bottomImg={LogoBottom}
//     >
//       <div
//         style={{
//           width: "300px",
//           margin: "5px 0",
//           position: "relative",
//         }}
//       >
//         <Input
//           placeholder="Enter Your Password"
//           className={"password_inputs_fields"}
//           type={showPassword ? "text" : "password"}
//           value={formData.password}
//           inputName="password"
//           onKeyPress={(e) => e.key === "Enter" && handleLogin()}
//           onchangeInput={(e) =>
//             setFormData((prev) => ({ ...prev, password: e.target.value }))
//           }
//           length={50}
//           disabled={loading}
//           loading={loading}
//           style={{ paddingRight: "40px" }}
//         />

//         {/* Eye Icon */}
//         <span
//           onClick={() => setShowPassword((prev) => !prev)}
//           style={{
//             position: "absolute",
//             right: "12px",
//             top: "50%",
//             transform: "translateY(-50%)",
//             cursor: "pointer",
//             color: "#666",
//             fontSize: "18px",
//           }}
//         >
//           {showPassword ? <FaEye /> : <FaEyeSlash />}
//         </span>
//       </div>

//       {/* Error message */}

//       {error && <div className="error-message text-red-500 ">{error}</div>}

//       {/* Loading message */}

//       <Botton
//         onClick={handleLogin}
//         className={"NextBtn mt-3"}
//         // children={"Login"}
//         children={`${loading ? "Logging in..." : "Login"}`}
//         icon={FaArrowRightToBracket}
//       />

//       <p className="text-center mt-3 small fw-bold">
//         <Link
//           to="/forget-password"
//           className="text-primary cursor-pointer fw-semibold reset_btn"
//         >
//           Forgot Password?
//         </Link>
//       </p>
//     </AuthCard>
//   );
// };

// export default Password;
